<template>
  <div class="app">
    <JakartoLogin @authenticated="onAuthenticated" />

    <main v-if="isAuthenticated" class="app-main">
      <CesiumViewer />
    </main>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import CesiumViewer from "@/components/CesiumViewer.vue";
import JakartoLogin from "@/components/JakartoLogin.vue";

const isAuthenticated = ref(false);

function onAuthenticated(status: boolean) {
  isAuthenticated.value = status;
}
</script>

<style scoped>
.app {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.app-header {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
  color: white;
  padding: 20px;
  text-align: center;
}

.app-header h1 {
  margin: 0 0 8px 0;
  font-size: 2rem;
  font-weight: 600;
}

.app-header p {
  margin: 0;
  font-size: 1rem;
  opacity: 0.9;
}

.app-main {
  width: 100%;
  height: 100%;
  position: relative;
}

/* Reset default margins and padding */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}
</style>
